import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

//https://youtu.be/a_7Z7C_JCyo?t=2877

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
